module.exports = "img/button-text-block-quote.b53cc06.svg";